import { CommonModule } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { MsGraphAPI } from '../../api/ms-graph-api.service';
import { ApplicationState } from '../../state/application-state.service';

@Component({
  selector: 'app-user-profile-nav-item',
  imports: [CommonModule],
  templateUrl: './user-profile-nav-item.component.html',
})
export class UserProfileNavItemComponent {

  collapsed = input<boolean>(false);

  authService = inject(MsalService);
  applicationStateService = inject(ApplicationState);
  msGraphService = inject(MsGraphAPI);

  isAuthenicated = this.applicationStateService.isAuthenticated;
  me = computed(() => {
    if (this.isAuthenicated()) {
      return this.msGraphService.getMe();
    }
    return null;
  });
  myPhoto = computed(() => {
    if (this.isAuthenicated()) {
      return this.msGraphService.getMyPhoto();
    }
    return null;
  });

  constructor() { }

  ngOnInit(): void {
  }

  logout() {
    this.authService.logoutRedirect();
  }
}
